import moment from 'moment-timezone';
import { OpeningHoursWithExceptions, FixedTimesObject, OpeningHourTimes } from 'common/types';
import { getOpeningTimesForDate } from 'common/utils/shopUtils';
import { dayTypesToNumbers } from 'common/utils/dateUtils';

export const getFixedStartTimesForDate = (
	date: moment.Moment,
	fixedTimes: FixedTimesObject[],
	outsideOpeningHours: boolean,
	openingHoursWithExceptions: OpeningHoursWithExceptions,
) => {
	const openingTimes = getOpeningTimesForDate(date, openingHoursWithExceptions);
	if (!openingTimes || (!outsideOpeningHours && openingTimes.isClosed)) {
		return [];
	}
	const startTimes = !outsideOpeningHours
		? getStartTimesFromFixedTimes(date, fixedTimes, openingTimes)
		: getStartTimesFromFixedTimes(date, fixedTimes);
	return startTimes;
};

export const getStartTimesFromFixedTimes = (
	date: moment.Moment,
	fixedTimes: FixedTimesObject[],
	openingTimes?: OpeningHourTimes,
): string[] => {
	let startTimes: string[] = [];
	for (const fixedTimesObject of fixedTimes) {
		if (fixedTimesObject.dayType === 'custom') {
			if (date.format('DD-MM-YYYY') === moment(fixedTimesObject.customDate).format('DD-MM-YYYY')) {
				if (openingTimes) {
					if (
						openingTimes?.openTime <= fixedTimesObject.time &&
						openingTimes?.closeTime >= fixedTimesObject.time
					) {
						startTimes = [...startTimes, fixedTimesObject.time];
					}
				} else {
					startTimes = [...startTimes, fixedTimesObject.time];
				}
			}
		} else {
			const arrayOfDays = dayTypesToNumbers[fixedTimesObject.dayType] ?? [];
			const dayNumber = date.day();
			for (const dayOfTheWeek of arrayOfDays) {
				if (dayOfTheWeek === dayNumber) {
					if (openingTimes) {
						if (
							openingTimes?.openTime <= fixedTimesObject.time &&
							openingTimes?.closeTime >= fixedTimesObject.time
						) {
							startTimes = [...startTimes, fixedTimesObject.time];
						}
					} else {
						startTimes = [...startTimes, fixedTimesObject.time];
					}
				}
			}
		}
	}
	const returnArray = startTimes.filter((v, i) => startTimes.indexOf(v) === i).sort();
	return returnArray;
};
